import { calendarDaysSince } from '@/lib/calendar-days'
import dayjs from '@/lib/dayjs'
import type { ConfigType, Dayjs } from 'dayjs'
import type { CashDrawerIdInput } from './cash-drawers.types'

// Tills have no required schedule. After a week open, staff are nudged to count the drawer.
export const LONG_OPEN_TILL_DAYS = 7

export function getCashDrawerOptionLabel(
  drawer?: { workstation?: { name?: string } | null; location?: { name?: string } | null } | null
) {
  const registerName = drawer?.workstation?.name
  const locationName = drawer?.location?.name

  if (registerName && locationName) return `${registerName} — ${locationName}`

  return registerName || locationName || 'Register'
}

/** Calendar days a till has been open in the organization timezone. */
export function getTillOpenAge(openedAt: ConfigType, now: Dayjs = dayjs()) {
  const days = calendarDaysSince(openedAt, now)

  return {
    days,
    isLongOpen: days >= LONG_OPEN_TILL_DAYS,
  }
}

/** Short "started" or "last counted" date: today with a time, otherwise the date. */
export function formatTillDate(value: ConfigType, now: Dayjs = dayjs()) {
  const date = dayjs(value)

  if (date.isSame(now, 'day')) return `today at ${date.format('h:mm A')}`
  if (date.isSame(now, 'year')) return date.format('ddd, MMM D')

  return date.format('MMM D, YYYY')
}

interface LocationOwner {
  location_id?: CashDrawerIdInput
  location?: { id?: CashDrawerIdInput } | null
}

/**
 * Location whose till handles a record's cash or check: each record's flat `location_id`, then its
 * nested `location.id`, in the order given (for example order before cart). 0 when none is known.
 */
export function manualTenderLocationId(
  ...records: Array<LocationOwner | null | undefined>
): number {
  for (const record of records) {
    const locationId = Number(record?.location_id ?? record?.location?.id ?? 0)
    if (locationId > 0) return locationId
  }

  return 0
}
